import React from 'react';
import { AgentIconBadge, type AgentIconProps } from './AgentIconBase';

const CYBER_PULSE_SHIELD_PATH =
  'M75 36 L103 46 V78 C103 98 91 110 75 117 C59 110 47 98 47 78 V46 Z';
const CYBER_PULSE_WAVEFORM_PATH = 'M53 82 H66 L70 74 L75 88 L80 66 L85 82 H97';

export default function CyberPulseAgent(props: AgentIconProps) {
  return (
    <AgentIconBadge {...props}>
      <path fill="#fff" d={CYBER_PULSE_SHIELD_PATH} />
      <path
        fill="none"
        stroke="#0057a8"
        strokeWidth="6"
        strokeLinecap="round"
        strokeLinejoin="round"
        d={CYBER_PULSE_WAVEFORM_PATH}
      />
    </AgentIconBadge>
  );
}
